import type { AncillaryBundleOptionType, AncillaryBundlesType } from '../../models';

export const getSelectedAncillaryBundleOptions = (ancillaryBundles: AncillaryBundlesType) =>
  ancillaryBundles.reduce((acc: AncillaryBundleOptionType[], ancillaryBundle) => {
    const ancillaryOption = ancillaryBundle.options.find(
      (option) => option?.id === ancillaryBundle.selectedOption,
    );
    if (ancillaryOption) {
      acc.push(ancillaryOption);
    }
    return acc;
  }, []);
